import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { UAParser } from 'ua-parser-js';

import { useAuth } from "../context/clientContext";
import NotFound from "../pages/notFound";

export default function ClientRoute({ component: Component, ...rest }) {
  // Obtener el estado de autenticación del contexto
  const { user, token, uuid } = useAuth();
  const location = useLocation();

  /** PARAMS */
  const { qr } = useParams();

  // Obtención de data
  const getClientData = () => {
    const parser = new UAParser();
    const result = parser.getResult();

    const type = qr ? 'qr' : (result.device.type || 'desktop');

    return {
      so: result.os.name,
      browser: `${result.browser.name} ${result.browser.version}`,
      version: process.env.REACT_APP_VERSION || '1.0.0',
      channel: type,
      type: result.device.model || 'unknown',
      model_id: result.device.model || 'unknown',
      host: window.location.hostname,
      uri: window.location.pathname,
      language: navigator.language,
    };
  };

  useEffect(() => {
    const data = getClientData();

    // Enviar los datos al backend
    fetch(`${process.env.REACT_APP_API_URL}/api/report/post/activity`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).catch(() => { });
  }, [location.pathname, user]);

  return <Component {...rest} />;
}